/* eslint-disable no-restricted-syntax */
const fontSizes = {
  desktop: {
    '--font-size-desk-h1': '28px',
    '--font-size-desk-h2': '24px',
    '--font-size-desk-h3': '20px',
    '--font-size-desk-h4': '18px',
    '--font-size-desk-h4-semibold': '18px',
    '--font-size-desk-regular': '16px',
    '--font-size-desk-semibold': '16px',
    '--font-size-desk-small': '14px',
    '--font-size-desk-small-semibold': '14px',
    '--font-size-desk-inputs': '12px'
  },
  mobile: {
    '--font-size-desk-h1': '26px',
    '--font-size-desk-h2': '20px',
    '--font-size-desk-h3': '18px',
    '--font-size-desk-h4': '16px',
    '--font-size-desk-h4-semibold': '16px',
    '--font-size-desk-regular': '14px',
    '--font-size-desk-semibold': '14px',
    '--font-size-desk-small': '12px',
    '--font-size-desk-small-semibold': '12px',
    '--font-size-desk-inputs': '10px'
  }
};

type FontSize = 'desktop' | 'mobile';

function setFontSizes(size: FontSize): void {
  for (const [key, value] of Object.entries<string>(fontSizes[size])) {
    document.documentElement.style.setProperty(key, value);
  }
}
export default setFontSizes;
